import {
  AssetMobileActionButton,
  AssetMobileAlert,
  AssetMobileCard,
  AssetMobileCardBody,
  AssetMobileCardMain,
  AssetMobileCardSubtitle,
  AssetMobileCardTitle,
  AssetMobileDataTable,
  AssetMobileDetailButton,
  AssetMobileDetailLabel,
  AssetMobileDetailRow,
  AssetMobileDetailRows,
  AssetMobileDetailSection,
  AssetMobileDetailSectionHeader,
  AssetMobileDetailValue,
  AssetMobileEmptyState,
  AssetMobileField,
  AssetMobileFilterActions,
  AssetMobileFilterApplyButton,
  AssetMobileFilterButton,
  AssetMobileFilterDrawer,
  AssetMobileFilterField,
  AssetMobileFilterFields,
  AssetMobileFilterForm,
  AssetMobileFilterRow,
  AssetMobileFilterSelect,
  AssetMobileForm,
  AssetMobileHeaderActions,
  AssetMobileIconButton,
  AssetMobileInfoGrid,
  AssetMobileInfoItem,
  AssetMobileInfoLabel,
  AssetMobileInfoValue,
  AssetMobileList,
  AssetMobileMoreButton,
  AssetMobilePage,
  AssetMobilePageButton,
  AssetMobilePagination,
  AssetMobilePaginationActions,
  AssetMobilePaginationInfo,
  AssetMobileSearch,
  AssetMobileSecondaryButton,
  AssetMobileSection,
  AssetMobileSectionHeader,
  AssetMobileSwitchField,
  MobileAssetHeader,
} from '../asset/mobile';
import styled from 'styled-components';

export const DeviceMobilePage = AssetMobilePage;
export const DeviceMobileActionButton = AssetMobileActionButton;
export const DeviceMobileAlert = AssetMobileAlert;
export const DeviceMobileCard = AssetMobileCard;
export const DeviceMobileCardBody = AssetMobileCardBody;
export const DeviceMobileCardMain = styled(AssetMobileCardMain)`
  grid-template-columns: minmax(0, 1fr) 20px;
`;
export const DeviceMobileCardSubtitle = AssetMobileCardSubtitle;
export const DeviceMobileCardTitle = AssetMobileCardTitle;
export const DeviceMobileDataTable = AssetMobileDataTable;
export const DeviceMobileDetailButton = AssetMobileDetailButton;
export const DeviceMobileDataLogButton = styled(AssetMobileDetailButton)`
  background: #264284;
  color: #ffffff;

  &:hover,
  &:focus {
    background: #264284;
    color: #ffffff;
  }
`;
export const DeviceMobileDetailLabel = AssetMobileDetailLabel;
export const DeviceMobileDetailRow = AssetMobileDetailRow;
export const DeviceMobileDetailRows = AssetMobileDetailRows;
export const DeviceMobileDetailSection = AssetMobileDetailSection;
export const DeviceMobileDetailSectionHeader = AssetMobileDetailSectionHeader;
export const DeviceMobileDetailValue = AssetMobileDetailValue;
export const DeviceMobileEmptyState = AssetMobileEmptyState;
export const DeviceMobileField = styled(AssetMobileField)`
  && {
    margin-bottom: 10px;
  }

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .ant-form-item-label > label {
    color: #1e1e1e;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  .ant-input,
  .ant-select-selector {
    min-height: 44px;
    border-color: #e8ecf3 !important;
    border-radius: 6px !important;
    background: #ffffff !important;
    box-shadow: none !important;
    color: #1e1e1e;
    font-size: 12px;
  }

  .ant-input[disabled],
  .ant-select-disabled .ant-select-selector {
    background: #f5f6f9 !important;
    color: #768499;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    color: #1e1e1e;
    font-size: 12px;
  }

  .ant-select-selection-placeholder,
  .ant-input::placeholder {
    color: #bfbfbf;
  }
`;
export const DeviceMobileFilterActions = AssetMobileFilterActions;
export const DeviceMobileFilterApplyButton = AssetMobileFilterApplyButton;
export const DeviceMobileFilterButton = AssetMobileFilterButton;
export const DeviceMobileFilterDrawer = AssetMobileFilterDrawer;
export const DeviceMobileFilterField = AssetMobileFilterField;
export const DeviceMobileFilterFields = AssetMobileFilterFields;
export const DeviceMobileFilterForm = AssetMobileFilterForm;
export const DeviceMobileFilterRow = AssetMobileFilterRow;
export const DeviceMobileFilterSelect = AssetMobileFilterSelect;
export const DeviceMobileForm = styled(AssetMobileForm)`
  padding: 12px 0 24px;
`;
export const DeviceMobileHeaderActions = AssetMobileHeaderActions;
export const DeviceMobileIconButton = AssetMobileIconButton;
export const DeviceMobileInfoGrid = AssetMobileInfoGrid;
export const DeviceMobileInfoItem = AssetMobileInfoItem;
export const DeviceMobileInfoLabel = AssetMobileInfoLabel;
export const DeviceMobileInfoValue = AssetMobileInfoValue;
export const DeviceMobileList = AssetMobileList;
export const DeviceMobileMoreButton = AssetMobileMoreButton;
export const DeviceMobilePageButton = AssetMobilePageButton;
export const DeviceMobilePagination = AssetMobilePagination;
export const DeviceMobilePaginationActions = AssetMobilePaginationActions;
export const DeviceMobilePaginationInfo = AssetMobilePaginationInfo;
export const DeviceMobileSearch = AssetMobileSearch;
export const DeviceMobileSecondaryButton = AssetMobileSecondaryButton;
export const DeviceMobileSection = styled(AssetMobileSection)`
  margin-bottom: 16px;
  padding-bottom: ${(props) => (props.$bordered ? '16px' : '0')};
`;

export const DeviceMobileSectionHeader = styled(AssetMobileSectionHeader)`
  margin-bottom: 12px;

  h2 {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
  }

  p {
    margin-top: 4px;
    color: #768499;
    font-size: 12px;
    line-height: 1.2;
  }
`;
export const DeviceMobileSwitchField = AssetMobileSwitchField;
export const MobileDeviceHeader = MobileAssetHeader;

export const DeviceMobileResultCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 44px;
  margin: 2px 0 8px;
  padding: 10px 12px;
  border: 1px solid #cfe1ff;
  border-radius: 6px;
  background: #f4f8ff;
  color: #1e1e1e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
`;

export const DeviceMobileWarningCard = styled.div`
  width: 100%;
  margin-bottom: 0;
  padding: 10px 12px;
  border: 1px solid #ffe7ba;
  border-radius: 6px;
  background: #fffbe6;
  color: #8c6d1f;
  font-size: 12px;
  line-height: 1.35;
`;

export const DeviceMobileDetailTabs = styled.div`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-content-holder {
    padding-top: 16px;
  }
`;
